module.exports = __webpack_public_path__ + "img/JohtoPreview.3531bf4e.png";